import React, {useEffect} from "react";
import {Box, Grid} from "@mui/material";
import {Field, reduxForm, reset} from "redux-form";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";
import {currentPage} from "_constants";
import {userActions} from "_actions";
import {required} from "_helpers";
import {Loading} from "../../../common";
import BasicFormTextField from "../../common/BasicFormTextField";
import ActionButton from "../../common/ActionButton";
import AnchorButton from "../../common/AnchorButton";
import {usePasswordStatusRedirect} from "../UserManagement/Utilities/hooks/usePasswordStatusRedirect";

function UpdatePassword({ handleSubmit }){
    usePasswordStatusRedirect(currentPage.UPDATE_PASSWORD);

    const dispatch = useDispatch();
    const passwordUpdate = useSelector((state) => state.users.passwordUpdate);
    const loadingPasswordUpdate = passwordUpdate?.loading;

    const passwordStatus = useSelector((state) => state.userInvite.passwordStatus);
    const loadingPasswordStatus = passwordStatus?.loading;

    const handleUpdatePassword = (values) => {
        if(_.isEmpty(values)) return;
        dispatch(userActions.updatePassword(values));
    };

    useEffect(() => {
        if (passwordUpdate?.data) {
            dispatch(reset('UpdatePasswordForm'));
        }
    }, [passwordUpdate?.data, dispatch]);

    if(loadingPasswordStatus){
        return <Loading/>
    }

    return(
        <Box sx={styles.rootWrapper}>
            <Box sx={styles.container}>
                <Box component={"h1"} sx={styles.headingText}>Change Password</Box>

                <form name="form" onSubmit={handleSubmit(handleUpdatePassword)} autoComplete="off">
                    <Grid container sx={{marginTop: { xs: '20px', sm: '25px', }}}>
                    <Grid item sx={styles.formContainer} xs={12} md={6} lg={4}>
                        <Box mb={{xs: "10px", sm: "10px", md: "15px", lg: "15px"}}>
                            <Box sx={styles.inputDesc}>Current Password</Box>
                            <Field
                                type="password"
                                name="currentPassword"
                                component={BasicFormTextField}
                                validate={required}
                            />
                        </Box>
                        <Box mb={{xs: "10px", sm: "10px", md: "15px", lg: "15px"}}>
                            <Box sx={styles.inputDesc}>New Password</Box>
                            <Field
                                type="password"
                                name="newPassword"
                                component={BasicFormTextField}
                                validate={required}
                            />
                        </Box>
                        <Box mb={{xs: "15px", sm: "15px", md: "20px", lg: "20px"}}>
                            <Box sx={styles.inputDesc}>Confirm Password</Box>
                            <Field
                                type="password"
                                name="confirmPassword"
                                component={BasicFormTextField}
                                validate={required}
                            />
                        </Box>

                        <Box sx={styles.footer}>
                            <Box sx={{width: '100px'}}>
                                <ActionButton
                                    label={'Save'}
                                    disabled={loadingPasswordUpdate}
                                />
                            </Box>
                            <Box sx={{width: '100px'}}>
                                <AnchorButton
                                    label={'Cancel'}
                                    link={'/profile'}
                                    buttonBordered={true}
                                />
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                </form>

            </Box>
        </Box>
    )
}

const styles = {
    rootWrapper: {
        backgroundColor: '#edede4',
        pt: '135px',
        pb: 10,
        minHeight: '100vh',
    },
    container: {
        px: { xs: 2, sm: 6 },
        maxWidth: '1440px',
        position: 'relative',
        marginTop: '-2px'
    },
    headingText: {
        m: 0,
        fontFamily: 'IvyPrestoHeadlineRegular',
        fontSize: '35px',
        lineHeight: 0.8,
        color: '#0C2728',
        letterSpacing: '0.03em'
    },
    formContainer: {
        backgroundColor: '#FFF',
        border: '1px solid #CED4D4',
        borderRadius: '10px',
        padding: '20px'
    },
    inputDesc: {
        fontFamily: 'FustatSemiBold',
        fontSize: '14px',
        fontWeight: 500,
        color: '#003300',
        mb: '7px'
    },
    footer: {
        display: 'flex',
        gap: '18px'
    },
}

function validate(values) {
    const errors = {}
    const {currentPassword, newPassword, confirmPassword} = values

    if(_.isEmpty(_.toString(currentPassword)) || currentPassword === 'none') errors.currentPassword = "invalid password";
    if(_.isEmpty(_.toString(newPassword)) || newPassword === 'none') errors.newPassword = "invalid password";
    if(_.isEmpty(_.toString(confirmPassword)) || confirmPassword === 'none') errors.confirmPassword = "invalid password";
    return errors;
}

const formConfig = {
    form: 'UpdatePasswordForm',
    validate
};

UpdatePassword = reduxForm(formConfig)(UpdatePassword)
export default UpdatePassword